import { Link } from 'react-router-dom';
import type { Category } from '@/mocks/categories';

interface CategoryCardProps {
  category: Category;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.slug}`}
      className="group flex flex-col items-center p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 text-center"
    >
      <div className="w-14 h-14 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
        <span className="w-6 h-6 flex items-center justify-center">
          <i className={`${category.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
        </span>
      </div>
      <h3 className="mt-4 text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
        {category.name}
      </h3>
      <p className="mt-2 text-xs text-foreground-600 font-body leading-relaxed line-clamp-2">
        {category.description}
      </p>
      <span className="mt-3 text-xs text-foreground-400 font-body">
        {category.articleCount} 篇文章
      </span>
    </Link>
  );
}